/* eslint-disable consistent-return */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import IconConfirmationTick from '../../common/icon/variants/IconConfirmationTick';
import IconInformation from '../../common/icon/variants/IconInformation';
import IconWarning from '../../common/icon/variants/IconWarning';
import IconError from '../../common/icon/variants/IconError';

const CLASS_PREFIX = 'c-snackbar';

const SNACKBAR_CONFIG = {
  success: {
    color: '#4caf50',
    icon: <IconConfirmationTick rectFill="white" pathFill="#4caf50" />,
    textColor: 'white',
  },
  warn: {
    color: '#ffc107',
    icon: <IconWarning />,
    textColor: 'black',
  },
  error: {
    color: '#f44336',
    icon: <IconError />,
    textColor: 'black',
  },
  default: {
    color: '#263238',
    icon: <IconInformation stroke="white" fill="#263238" />,
    textColor: 'white',
  },
};

const Snackbar = ({ message, triggerSnackbar, type }) => {
  const [showSnackbar, setShowSnackbar] = useState(false);

  const { color, icon, textColor } =
    SNACKBAR_CONFIG[type] || SNACKBAR_CONFIG.default;

  useEffect(() => {
    if (triggerSnackbar > 0) {
      setShowSnackbar(true);
      const timer = setTimeout(() => setShowSnackbar(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [triggerSnackbar]);

  if (!message || triggerSnackbar === 0) {
    return null;
  }

  return (
    <div
      style={{ background: color, color: textColor }}
      aria-hidden={!showSnackbar}
      className={`${CLASS_PREFIX} ${
        showSnackbar ? `${CLASS_PREFIX}--show` : `${CLASS_PREFIX}--hide`
      }`}
    >
      {icon}
      <span className={`${CLASS_PREFIX}__message`}>{message}</span>
    </div>
  );
};

Snackbar.propTypes = {
  message: PropTypes.string.isRequired,
  triggerSnackbar: PropTypes.number.isRequired,
  type: PropTypes.oneOf(['success', 'warn', 'error']),
};

export default Snackbar;
